<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}" *ngIf="user && showAllUsers == true">
    <section class="professional-home-page-container container">
        <section class="template-section-title">
			<div class="title-container">
				<h1>Professional Manager</h1>
			</div>
		</section>

        <section class="professional-home-page-presentation">
            <div class="professional-company-name">
                <div class="img">
                    <img *ngIf="!logoUrl" src="../../assets/img/professional-logo.png" alt="Company Logo will be displayed here"
                        width="120px" (click)="uploadLogo.click()">
                    <img *ngIf="logoUrl" src="{{logoUrl}}" alt="{{user.company}}" width="100px" (click)="uploadLogo.click()">
                </div>
                <div class="company-name">{{user.company}}</div>
            </div>
            <div class="professional-menu-columns">
                <div class="professional-menu column-1">
                    <div class="box-menu" (click)="statusResources=!statusResources">Resources</div>
                </div>
                <div class="professional-menu column-2">
                    <div class="box-menu" (click)="statusClientIssues=!statusClientIssues">Client Licenses</div>
                </div>
            </div>
        </section>
        <section class="dynamic-collapse">
            <section class="dynamic-collapse-header-toggle"
                [ngClass]="statusResources ? 'dynamic-collapse-header-collapsed' : ''"
                (click)="statusResources=!statusResources">
                <div class="title-label">
                    <h3 class="title-section">Resources</h3>
                </div>
                <div>
                    <img class="minimize-svg" src="../../assets/img/default/top-arrow.svg"
                        [ngClass]="statusResources ? 'minimize-collapsed' : ''" alt="">
                </div>
            </section>
            <section class="dynamic-collapse-main">
                <section class="dynamic-collapse-content"
                    [ngClass]="statusResources ? 'help-collapse-main-collapsed' : ''">
                    <div class="resources-content">
                        <div class="resources-link">
                            <div class="title-info">
                                <div class="title">
                                    <div class="text">Professional sign up link</div>
                                    <div class="info" ngbTooltip="{{clientSignUpLink}}" placement="top">
                                        <!-- <img src="../../assets/img/info-btn.svg" ngbTooltip="{{clientSignUpLink}}" placement="top" height="35px" alt=""> -->
                                        <div class="svg-container help-btn-svg-container">
                                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 832.46 905" width="30px">
                                                
                                                <path
                                                    d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                                    transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                                <path
                                                    d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                                    transform="translate(-95.77 -59.5)" fill="#fff" />
                                                <path
                                                    d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                                                <path
                                                    d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div class="sign-up-link">
                                    <a [href]="'https://app.zenplans.com/sign-up/' + refCode" target="_blank" class="link">app.zenplans.com/sign-up/{{refCode}}</a>
                                    <span class="text-copied" *ngIf="textCopied">Text Copied!</span>
                                    <button (click)="copyText('https://app.zenplans.com/sign-up/' + refCode)" value="click to copy" >Copy Link</button>
                                </div>
                            </div>
                        </div>
                        <div class="resources-link resources-link-loader">
                            <div class="title-info">
                                <div class="title">
                                    <div class="text">Change company logo</div>
                                    <div class="info" ngbTooltip="{{changeLogoTooltip}}" placement="top"  >
                                        <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                                        <div class="svg-container help-btn-svg-container">
                                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 832.46 905" width="30px">
                                                
                                                <path
                                                    d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                                    transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                                <path
                                                    d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                                    transform="translate(-95.77 -59.5)" fill="#fff" />
                                                <path
                                                    d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                                                <path
                                                    d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div class="upload-loader" *ngIf="currentFile && !dataIsLoaded">
                                    <app-loader *ngIf="!dataIsLoaded"></app-loader>
                                </div>

                                <div class="upload" (click)="uploadLogo.click()">New Logo</div>
                                <form method="post" enctype="multipart/form-data" style="display:none;">
                                    <input #uploadLogo type="file" (change)="fileUpload($event)" accept="image/*"/>
                                </form>
                            </div>
                            <div *ngIf="message" class="error-upload" role="alert">{{ message }}</div>
                        </div>
                    </div>
                </section>
            </section>
        </section>

        <section class="dynamic-collapse">
            <section class="dynamic-collapse-header-toggle"
                [ngClass]="statusClientIssues ? 'dynamic-collapse-header-collapsed' : ''"
                (click)="statusClientIssues=!statusClientIssues">
                <div class="title-label">
                    <h3 class="title-section">Client Licenses</h3>
                    <div class="label" *ngIf="!statusClientIssues">
                        {{professionalAccounts.length}}
                    </div>
                </div>
                <div>
                    <img class="minimize-svg" src="../../assets/img/default/top-arrow.svg"
                        [ngClass]="statusClientIssues ? 'minimize-collapsed' : ''" alt="">
                </div>
            </section>
            <section class="dynamic-collapse-main">
                <section class="dynamic-collapse-content"
                    [ngClass]="statusClientIssues ? 'help-collapse-main-collapsed' : ''">
                    <div class="client-licenses-content">
                        <div>
                            <span class="accounts-number">{{professionalAccounts.length}}</span>
                            <span>professional accounts created via your professional sign up link</span>
                        </div>
                        <div>
                            <span class="accounts-number">{{totalLicenses}}</span>
                            <span> client accounts created by all professionals</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">First Name</th>
                                        <th scope="col">Last Name</th>
                                        <th scope="col">Email Address</th>
                                        <th scope="col">Sign Up Links</th>
                                        <th scope="col">Client Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let account of professionalAccounts" (click)="onSelect(account)">
                                        <td>{{account.firstName}}</td>
                                        <td>{{account.lastName}}</td>
                                        <td>{{account.email}}</td>
                                        <td>{{account.refCode}}</td>
                                        <td>{{account.licenses.length}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </section>
        </section>
        
    </section>
</section>
<app-professional-manager-account-details *ngIf="userDetail == true" [account]="selectedUser" (onClick)="backFromDetailUser()"
					 (userOutputValue)="displayUserData($event)"></app-professional-manager-account-details>
